import { z, ZodString } from "zod";

export function requiredString(message = "Tidak boleh kosong"): ZodString {
  return z
    .string(message)
    .trim() // Remove whitespace for validation
    .min(1, { message }); // For empty string input
}
